export const CHECKOUT_URL = "https://facial-en.impultienda.ar/checkout/";

export const IMAGES = {
  mockup: "https://cdn.magicpatterns.com/uploads/aTmikh2U5DBhzDPdRFcecd/MOCKUP_FACIAL-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/uiHe5ohNQQyce3GdYCM6Na/MICHAEL_CARTER_-_IMPLANTES.png",
};

export const SCARCITY = { spotsLeft: 7, filledPercent: 93 };

export const collectionIncludes = [
  "6 specialized educational volumes",
  "5 professional bonuses",
  "Patient assessment frameworks",
  "Clinical documentation templates",
  "Educational case studies",
  "Clinical safety review checklists",
  "Structured follow-up worksheets",
];

export const offerItems = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Assessment frameworks and worksheets",
  "Documentation templates",
  "Educational case studies",
  "Clinical safety review resources",
  "No recurring subscription",
];

export const finalIncludes = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Patient assessment frameworks",
  "Clinical documentation templates",
  "Educational case studies",
  "Clinical safety review resources",
  "Digital access",
  "One-time payment",
];

export const volumeTopics = [
  "Patient assessment frameworks",
  "Facial anatomy references",
  "Complication assessment",
  "Vascular warning signs",
  "Injectable treatment complications",
  "Clinical documentation and follow-up",
];

export const bonusValues = [
  { name: "Bonus 1: The Facial Aesthetic Clinical Casebook", value: "$19" },
  { name: "Bonus 2: The Pre-Procedure Assessment Toolkit", value: "$17" },
  { name: "Bonus 3: The Facial Aesthetic Warning Signs Atlas", value: "$19" },
  { name: "Bonus 4: The Patient Follow-Up Documentation Toolkit", value: "$17" },
  { name: "Bonus 5: The Clinical Safety Audit Workbook", value: "$19" },
];

export const heroStory = [
  "You have invested time in learning facial anatomy, aesthetic procedures, patient assessment, and clinical safety.",
  "But when you need to review a complex case, organize patient information, or revisit important safety considerations, finding the right information across multiple resources can be frustrating.",
  "That’s why I created the FACIAL AESTHETICS CLINICAL ROADMAP™ concept: an organized educational collection designed to help facial aesthetic practitioners structure their clinical references and approach professional preparation more systematically.",
  "Inside, you’ll find 6 specialized educational volumes, 5 professional bonuses, practical assessment frameworks, documentation templates, and structured clinical review tools.",
  "Everything is organized around one central idea: making it easier to study, organize, and revisit the educational information relevant to facial aesthetic practice.",
];
